import { UseFormValues } from "@formiz/core/dist/types/form.types";
import { Dispatch, SetStateAction } from "react";

export enum OnboardingStep {
  WELCOME_ABOARD = "WelcomeAboard",
  COMMUNITY_GUIDELINES = "CommunityGuidelines",
}

export interface WelcomeAboardModalProps {
  isUsernameAvailable: boolean | null;
  isCheckingUsername: boolean;
  userForm: UseFormValues;
  setSelectedOnboardingStep: Dispatch<SetStateAction<OnboardingStep | null>>;
}

export interface GuidelinesModalProps {
  submitForm: () => void;
  isSubmitting: boolean;
}
